export const flags: IFlags = {
  showPastSessionsBlock: process.env.NEXT_PUBLIC_FLAG_SHOW_PAST_SESSIONS_BLOCK
};

type IFlags = {
  showPastSessionsBlock: string | undefined;
};
